import { render } from "./MvCol3.vue?vue&type=template&id=0f7e87cc"
import script from "./MvCol3.vue?vue&type=script&lang=js"
export * from "./MvCol3.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__